import UI from "@mile-meeting/mile-ui";

const TableHeader = () => {
  return (
    <div
      style={{
        padding: "12px 24px",
        borderRadius: 12,
        gap: 20,
        display: "flex",
        alignItems: "center",
        backgroundColor: "var(--component-color-fill-alternative)",
      }}
    >
      <UI.Typography style={{ width: 266 }} type="label01">
        회의실
      </UI.Typography>
      <UI.Typography style={{ width: 80 }} type="label01">
        처리 상태
      </UI.Typography>
      <UI.Typography style={{ width: 180 }} type="label01">
        예약 제한 기간
      </UI.Typography>
      <UI.Typography style={{ flex: 1 }} type="label01">
        요청 사유
      </UI.Typography>
      <UI.Typography style={{ width: 80 }} type="label01">
        요청자
      </UI.Typography>
    </div>
  );
};

export default TableHeader;
